<template>
    <div class="vehicle-drilldown">
        <div class="change-vehicle" v-if="selectedVehicle">
            <strong>{{ label_your_selected_canopy }}</strong>
            <p>{{ selectedVehicle }}</p>
            <a href="javascript:;" class="full-button btn btn-hover btn-primary" @click="resetVehicle()">{{ label_change_canopy }}</a>
        </div>
        <div class="form" v-if="!selectedVehicle">
            <div class="form-content">
                <div class="form-row">
                    <label for>{{ label_manufacturer }} </label>
                    <select name id v-model="manufacturerId" :disabled="manufacturers.length == 0">
                        <option value="0" disabled>Select</option>
                        <option
                        v-for="(manufacturer, manufacturerIndex) in manufacturers"
                            :key="manufacturer.manufacturerId + manufacturerIndex"
                        :value="manufacturer.manufacturerId"
                        >{{ manufacturer.title }}</option>
                    </select>
                </div>
                <div class="form-row">
                    <label for>{{ label_canopy }} </label>
                    <select name id v-model="canopyId" :disabled="canopies.length == 0">
                        <option value="0" disabled>{{ label_select }}</option>
                        <option
                        v-for="(canopy, canopyIndex) in canopies"
                            :key="canopy.canopyId + canopyIndex"
                        :value="canopy.canopyId"
                        >{{ canopy.title }}</option>
                    </select>
                </div>
                <div class="form-row">
                    <label for>{{ label_vehicle_type }} </label>
                    <select name id v-model="vehicleTypeId" :disabled="vehicleTypes.length == 0">
                        <option value="0" disabled>{{ label_select }}</option>
                        <option
                        v-for="(type, typeIndex) in vehicleTypes"
                            :key="type.vehicleTypeId + typeIndex"
                        :value="type.vehicleTypeId"
                        >{{ type.title }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "canopy-manufacturers",
    data: function() {
        return {
            manufacturers: [],
            manufacturerId: 0,
            canopies: [],
            canopyId: 0,
            vehicleTypes: [],
            vehicleTypeId: 0,
            selectedVehicle: null
        }
    },
    props: {
        label_your_selected_canopy: {
            type: String,
            default: "Your selected canopy"
        },
        label_manufacturer: {
            type: String,
            default: "Manufacturer"
        },
        label_canopy: {
            type: String,
            default: "Canopy"
        },
        label_select: {
            type: String,
            default: "Select"
        },
        label_vehicle_type: {
            type: String,
            default: "Vehicle Type"
        },
        label_change_canopy: {
            type: String,
            default: "Change canopy"
        }
    },
    mounted() {
        this.getManufacturers();
    },
    methods: {
        async getManufacturers() {
            let response = await axios.get(`api/canopy/manufacturers`);
            this.manufacturers = response.data.data.sort(function(a,b){
                if (a.title > b.title) {
                    return 1;
                } else if (a.title == b.title) {
                    return 0;
                } else {
                    return -1;
                }
            });
        },
        canopyName() {
            var title = '';
            for (var i = 0; i < this.manufacturers.length; i++) {
                if (this.manufacturers[i].manufacturerId == this.manufacturerId) {
                    title = this.manufacturers[i].title;
                }
            }
            for (var i = 0; i < this.canopies.length; i++) {
                if (this.canopies[i].canopyId == this.canopyId) {
                    title = title + ' - ' + this.canopies[i].title;
                }
            }
            for (var i = 0; i < this.vehicleTypes.length; i++) {
                if (this.vehicleTypes[i].vehicleTypeId == this.vehicleTypeId) {
                    title = title + ' - ' + this.vehicleTypes[i].title;
                }
            }
            return title;
        },
        resetVehicle() {
            this.selectedVehicle = null;
            this.manufacturerId = 0;
            this.canopyId = 0;
            this.vehicleTypeId = 0;
            this.canopies = [];
            this.vehicleTypes = [];
            this.$emit('selectCanopy', {});
        }
    },
    watch: {
      async manufacturerId() {
        this.canopies = [];
        this.vehicleTypes = [];
        if (this.manufacturerId) {
            let response = await axios.get(`api/canopy/manufacturers/${this.manufacturerId}`);
            this.canopies = response.data.data;
        }
      },
      async canopyId() {
        this.vehicleTypes = [];
        if (this.canopyId) {
            let response = await axios.get(`api/solutions/item/1/canopy/${this.canopyId}`);
            this.vehicleTypes = response.data.data.vehicleTypes;
        }
      },
      async vehicleTypeId() {
        if (this.vehicleTypeId) {
            this.selectedVehicle = this.canopyName();
            this.$emit('selectCanopy', {vehicleId: this.canopyId + '/' + this.vehicleTypeId, full_name: this.selectedVehicle});
        }
      }
    }
};
</script>
